import React, { useState ,useEffect,useRef} from 'react';
import '../Agestvendas.css';
import { AreaChart,LineChart, Line ,Tooltip,CartesianGrid,XAxis,YAxis, Area,ResponsiveContainer} from 'recharts';
import parseISO from 'date-fns/parseISO';
import subDays from 'date-fns/subDays';
import format from 'date-fns/format';
import axios from 'axios';
import {toast,ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DialerSipRounded } from '@material-ui/icons';
import DatePicker from 'react-date-picker';
import ReactToPrint from 'react-to-print';
import {ComponentToPrint} from './Print';
import * as FaIcons from 'react-icons/fa';
import ReCAPTCHA from "react-google-recaptcha";
import ReactToExcel from 'react-html-table-to-excel';
import { Alert, Space, Spin } from 'antd';
toast.configure()



function AGestaVendas() {
    const [diario,setDiario]=useState(null);
    const [semanal,setSemanal]=useState(null);
    const [mensal,setMensal]=useState(null);
    const [personaliza,setPersonalizar]=useState(null);
    const[error,setError]=useState();
    const [valori,onChange]=useState(new Date());
    const [valorf,onChangef]=useState(new Date());
    const [aray,setAr]=useState(null);
    const [caixa,setcaixa]=useState(null);
    const [details, setDetails] = useState({ otp:"",username: "", password: "",nuit:"",telefone:"",meio:"" ,classe:""});
  const [Criar,setCriar]=useState('dfdf');
  const [recap,setRecap] = useState('sds');
  const [info,setInfo]=useState({nome:"",nuit:"",bi:"",telefone:"",provincia:"Maputo cidade",email:"",contador:"",morada:"",bairro:"Aeroporto A",cidade:"Maputo cidade",distrito:"Nlhamankulu"});
    const [cliented,setIDcl]=useState('');
    const printRelaResumo=useRef();
    const PrintCaixa=useRef();
    const [taxs_detalhes,setTaxs]=useState(null);
    const [valores_d,setValores_d]=useState({cod:'',nome:'',data:new Date().toISOString(),estado:'activo',min:'',precom:'',iva:'',precomax:''});
    const [diariod,setDiariod]=useState({m3:"",tsc:"",iva:"",valor:"",total:""});
    const [diariotax,setDiariotax]=useState({valorcalor:"",precogj:"",tsc:"",iva:"",valor:"",total:""});
    const [voucher,setVoucher]=useState(null);    
    const [monileapp,setMobileApp]=useState("");
    const [mbtako,setMobtako]=useState("");
    const [tipotaxaf,setTipotaxaf]=useState("");
    const [tipotaxi,setTipotaxi]=useState("");
    const [lisa,setLisa]=useState(null);
    const mcasa=useRef();
    const [load,setLoad]=useState('df');
    const [taxas,setTaxas]=useState(null);
    const [adicionar,setAdicionar]=useState(null);
    const [esquema,setEsquema]=useState(null);
    const [d,setd]=useState();
    const [revendedor,setRevendedor]=useState('');
    const [Bairro, setBairro]=useState('');
    useEffect(()=>{
        axios({
            method:"post",
            url:`${localStorage.getItem('url')}/web/dailydata/`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            data:{nrcontador:"19190120790"}
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( df=>{
            console.log(df.data)
            setLoad(null);
            setAr(df.data)
          
          }
       
           ).catch(e=>{
            setError(e.message );
        })
    
    },[])
     
const PERHandler=e=>{
    setDiario(null);
    setSemanal(null);
    setMensal(null);
    setPersonalizar('df');
 
}
const Taxas_compra=()=>{
    axios({
        method:"post",
        url:`${localStorage.getItem('url')}/web/TaxasCompra/`,
        headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
        data:{id:"sds"}
    }).then(dat=>{ if(dat.status!==200){
        throw Error('Dados de acesso invalidos');  
            }
        return dat
     } ).then( df=>{
         console.log(df.data);
         setTaxas(df.data);
      }
   
       ).catch(e=>{
        setError(e.message );
    })

}
const Tarif_scheme=()=>{
    axios({
        method:"post",
        url:`${localStorage.getItem('url')}/web/setSchemeTarif/`,
        headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
        data:diariotax
    }).then(dat=>{ if(dat.status!==200){
        throw Error('Dados de acesso invalidos');  
            }
        return dat
     } ).then( df=>{
        setd(df.data)
    }
   
       ).catch(e=>{
        setError(e.message );
    })
}
const Taxas_Update=()=>{
    axios({
        method:"post",
        url:`${localStorage.getItem('url')}/web/TaxasUpdate/`,
        headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
        data:diariotax
    }).then(dat=>{ if(dat.status!==200){
        throw Error('Dados de acesso invalidos');  
            }
        return dat
     } ).then( df=>{
         setTaxas(null);
        toast.success('Taxas Actualizadas com sucesso')
      }
   
       ).catch(e=>{
        setError(e.message );
    })
}
const Tokens_=()=>{
    axios({
        method:"post",
        url:`${localStorage.getItem('url')}/web/TokensRecarga`,
        headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
        data:{id:10118}
    }).then(dat=>{ if(dat.status!==200){
        throw Error('Dados de acesso invalidos');  
            }
        return dat
     } ).then( df=>{
        console.log(df.data);
        setLisa(df.data);
    }
   
       ).catch(e=>{
        setError(e.message );
    })

}
const Create_Scheme_Tarif=()=>{
    axios({
        method:"post",
        url:`${localStorage.getItem('url')}/web/createSchemeTarif/`,
        headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
        data:valores_d
    }).then(dat=>{ if(dat.status!==200){
        throw Error('Dados de acesso invalidos');  
            }
        return dat
     } ).then( df=>{
         toast.success('Adicionado com Sucesso!')
         setAdicionar(null);
        console.log('fgf');
     }
   
       ).catch(e=>{
        setError(e.message );
    })
}

const MONHandler=e=>{
    e.preventDefault();
    setDiario(null);
    setVoucher(null);
    setSemanal(null);
    setMensal(null);
    setEsquema(null);
    setcaixa(null);
    setPersonalizar(null);
    setTaxas(null);
    setMensal('dfd');

}
    const Diario=()=>{
         setDiario('dfd');
         setSemanal(null);
         setMensal(null);
        }
  const LHandler=e=>{
   e.preventDefault();
  }
  const DHandler=e=>{
    e.preventDefault();
    Diario();    
}
const SHandler=e=>{
    e.preventDefault();
    setTaxas(null)
    
    setDiario(null);
    setSemanal('sd');
    setMensal(null);
}
const CLOHandler=e=>{
    e.preventDefault();
}
const RELHandler=e=>{
    e.preventDefault();
    axios({
        method:"post",
        url:`${localStorage.getItem('url')}/web/dailyrelatorio/`,
        headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
        data:{id:"sds"}
    }).then(dat=>{ if(dat.status!==200){
        throw Error('Dados de acesso invalidos');  
            }
        return dat
     } ).then( df=>{
       
      }
   
       ).catch(e=>{
        setError(e.message );
    })


}
const FilterData=(row)=>{
   return row.filter((row)=>
    valori.getTime()<=(new Date(row.data_de_compra)).getTime() && (new Date(row.data_de_compra)).getTime() <=valorf.getTime())

}
const Search=(row)=>{
       
    return row.filter((row)=>
    row.metodo.toLowerCase().indexOf(revendedor.toLowerCase())>-1)
}
const SearchIDC=(row)=>{
       
    return row.filter((row)=>
    row.idCliente ===  parseInt(cliented) )
}
const FilterBairro=(row)=>{ 
    
    return row.filter((row)=>
    row.morada.toLowerCase().indexOf(Bairro.toLowerCase())>-1)   
}
const FilterRev=(row)=>{
    
    return row.filter((row)=>
    row.metodo.toLowerCase().indexOf('numerario')>-1)
}

const FilterRAKI=(row)=>{
        
    return row.filter((row)=>
    row.metodo.toLowerCase().indexOf('recargaaki')>-1)

}
const FilterEmola=(row)=>{
        
    return row.filter((row)=>
    row.metodo.toLowerCase().indexOf('emola')>-1)

}
const SomaIva=(row)=>{
    let soma=0;
    for(let i=0;i<row.length;i++){
        soma=soma+parseFloat(row[i].iva)
    }
    soma=soma.toFixed(2)
    return soma
}

const SomaY=(row)=>{
    let soma=0;
    soma=row.toFixed(2)
    return soma
}
const SomaTSC=(row)=>{
    let soma=0;
    for(let i=0;i<row.length;i++){
        soma=soma+parseFloat(row[i].tsc)
    }
    soma=soma.toFixed(2)
    return soma
    
}
const SomaVal=(row)=>{
    let soma=0;
    for(let i=0;i<row.length;i++){
        soma=soma+parseFloat(row[i].valor_pago)
    }
    soma=soma.toFixed(2)
    return soma
    
}
const RevHandler=(e)=>{
    e.preventDefault()
    setMensal(null);
    setPersonalizar(null);  
    setVoucher(null);
    setTaxas(null)
    setEsquema(null);
    setcaixa('sdsd')
}
const SomaMetros=(row)=>{
    let soma=0;
    for(let i=0;i<row.length;i++){
        soma=soma+parseFloat(row[i].metroscubicos)
    }
    soma=soma.toFixed(2)
    return soma
    
}
const Send=()=>{

}

const mobile=()=>{
    axios({
        method:"post",
        url:`${localStorage.getItem('url')}/web/dailydata/`,
        headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
        data:{id:"sds"}
    }).then(dat=>{ if(dat.status!==200){
        throw Error('Dados de acesso invalidos');  
            }
        return dat
     } ).then( df=>{
            setMobileApp('');
            setMobtako(df.data)
   }
   
       ).catch(e=>{
        setError(e.message );
    })

}
const MOBHandler=(e)=>{
    e.preventDefault()
    setDiario(null);
    setVoucher(null);
    setSemanal(null);
    setMensal(null);
    setcaixa(null);
    setEsquema(null);
    setTaxas(null);
    setPersonalizar('ss')
    
}
const TaxHandler=(e)=>{
    e.preventDefault();
    setDiario(null);
    setSemanal(null);
    setMensal(null);
    setcaixa(null);
    setPersonalizar(null);
    Taxas_compra();
    setVoucher(null);
    setEsquema(null);
}
const EskHandler=(e)=>{
    e.preventDefault();
    setDiario(null);
    setSemanal(null);
    setMensal(null);
    setcaixa(null);
    setVoucher(null);
    setPersonalizar(null);
    setTaxas(null);
    Tarif_scheme();
    setEsquema('dfd');
}
const UpdateHandler=(e)=>{
    Taxas_Update();
}
const A_Handler=(e)=>{
    e.preventDefault();
    Create_Scheme_Tarif();
}
const VouHandler=(e)=>{
    e.preventDefault();
    setDiario(null);
    setSemanal(null);
    setMensal(null);
    setcaixa(null);
    setPersonalizar(null);
    setTaxas(null);
    setEsquema(null);
    setVoucher('dfdf');
    Tokens_();

}
return <div className='Vendas'>
        <div className='Filtro'>
        {load && <>
            <Spin tip="Loading...">
      <Alert
        message="Carregando Informacao"
        description="Carregando as informacoes relacionadas as vendas"
        type="info"
      />
    </Spin>
        
        </>}


        { aray && <>
            <button  id="opcao" value="Nao"  onClick={MONHandler}>Resumo </button>
        <button  id="opcao" value="Nao  "  onClick={RevHandler}>Revendedores</button>
        <button  id="opcao" value="Nao"  onClick={MOBHandler}>Mobile App</button>
        <button  id="opcao" value="Nao"  onClick={TaxHandler}>Definir Taxas </button>  
        <button  id="opcao" value="Nao"  onClick={EskHandler}>Esquema de Precos</button>  
        <button  id="opcao" value="Nao"  onClick={VouHandler}>Chart</button>  
     
        
        </>}

        
        </div>
        {voucher && <div>
            <div className='elementos_filter'>
            <img  id="imagem_vendas"src={require('./images/clock.png')}  />
        
        <div>
        Inicio
        <DatePicker onChange={onChange} value={valori}/>
        </div>
        
        <img  id="imagem_vendas"src={require('./images/clock.png')}  />
    
        <div>
        Fim
        <DatePicker onChange={onChangef} value={valorf} maxDate={new Date()}/>
        </div>
        <div >ID do Cliente:
            <input className='nome_iop'  onChange={e=>setIDcl(e.target.value)} value={cliented} /></div>
 

            </div>
            <div>
            <img  id="imagem"src={require('./images/excel.png')}  />
            <ReactToExcel 
                    id='opcao'
                    table='tabela_singular'
                    filename='tabela_singular'
                    sheet='sheet 1'
                    buttonText='Exportar'/>

                </div>
            
            <div id='table_holder'>
            <table id='tabela_singular'>
            <thead>
            <tr>
            <th>Codigo do Cliente</th>
            <th>data de Compra</th>
            <th>metros cubicos</th>
            <th>tsc</th>
            <th>iva </th>
            <th>Valor pago</th>
           
            </tr>
            </thead>
    
     
            {aray && <tbody> {FilterData( SearchIDC(aray)).map((ct,key)=>{
        return<tr > 
        <td>{ct.idCliente}</td>
        <td>{ct.data_de_compra}</td>
        <td>{ct.idToken}</td>
        <td>{ct.tsc}</td>
        <td>{ct.iva}</td>
        <td>{ct.valor_pago}</td>
       
        </tr>
   
   
   })}    </tbody>}  
            </table>
            
          
            </div>
            {lisa && <div className='Totais'>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/vat (1).png')} /></div>
                        <div id="txts">IVA:</div>
                        <div id='valor'>{SomaIva(FilterData(lisa))}Mzn</div>
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/gas-pump.png')} /></div>
                        <div id="txts">TSC:</div>
                        <div id='valor'>{SomaTSC(FilterData(lisa))}Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/flame.png')} /></div>
                        <div id="txts"> Val gas:</div>
                        <div id='valor'>{SomaY(SomaVal(FilterData(lisa))-SomaIva(FilterData(aray))-SomaTSC(FilterData(lisa)))}Mzn</div>
                        
                    </div>
                    <div className='info'>
                    <img  id="imagem"src={require('./images/excel.png')}  />

<ReactToExcel 
id='opcao'
table='isso_ai'
filename='Lista_de_clientes'
sheet='sheet 1'
buttonText='Exportar'/>

                    </div>
                    
                   </div>
            
}
            
        </div>
        }
    
    
        {esquema && <div className='taxas_esquema'>
            <div id='yabela_esquema_precos'>
            <div id='table_holder'>
            <table>
            <thead>
            <tr>
            <th>Codigo</th>
            <th>Nome do esquema </th>
            <th>Data de Criacao</th>
            <th>Estado de Esquema</th>
            <th>Min m3</th>
            <th>preco min/m3</th>
           
            </tr>
            </thead>
    
     
  { d && <tbody> {d.map((ct,key)=>{
        return<tr onClick={()=>{setTaxs(ct)}}> 
        <td>{ct.idScheme}</td>
        <td>{ct.nome}</td>
        <td>{ct.data}</td>
        <td>{ct.estado}</td>
        <td>{ct.volume}</td>
        <td>{ct.nrdeinter}</td>
       
        </tr>
   
   
   })}    </tbody>}
    
            </table>
          
            </div>
            <div className='Filtro'>
        <button  id="opcao" value="Nao"  onClick={()=>{setAdicionar('sdsd')}}>Adicionar</button>
        <button  id="opcao" value="Nao  "  onClick={RevHandler}>Eliminar</button>
   
        </div>
        {adicionar && <div id='cabecasadd'><div id='cabeca'>
                        <div>Nome do Esquema:</div>
                        <input type='text' id='texto_cabeca' onChange={e=> setValores_d({...valores_d,nome:e.target.value})} value={valores_d.nome}/>

                    </div>
                    <div id='cabeca'>
                        <div>Estado:</div>
                        <input type='text' id='texto_cabeca' onChange={e=> setValores_d({...valores_d,estado:e.target.value})} value={valores_d.estado}/>
                    </div>
                    <div id='cabeca'>
                        <div>IVA:</div>
                        <input type='text' id='texto_cabeca' onChange={e=> setValores_d({...valores_d,iva:e.target.value})} value={valores_d.iva}/>
                    </div>
                    <div id='cabecas'>
                        <div>Volume minimo:</div>
                        <input type='text' id='texto_cabeca' onChange={e=> setValores_d({...valores_d,min:e.target.value})} value={valores_d.min}/>
                        <div>Preco:</div>
                        <input type='text' id='texto_cabeca' onChange={e=> setValores_d({...valores_d,precom:e.target.value})} value={valores_d.precom}/>
                        <div>Preco ao exceder Volume minimo:</div>
                        <input type='text' id='texto_cabeca' onChange={e=> setValores_d({...valores_d,precomax:e.target.value})} value={valores_d.precomax}/>
                        
                    </div>
                    <div className='Filtro'>
                    <button  id="opcao" onClick={A_Handler}>Salvar</button>
                    <button  id="opcao"  value="Nao" onClick={()=>{setAdicionar(null)}}>Cancelar</button>
                    </div>
       
        </div>}
     
       

            </div>
            
                <div id='data_esquema_precos'>
                    {taxs_detalhes && <div>
                        <div id='cabeca'>
                        <div>Nome do Esquema:</div>
                        <input type='text' id='texto_cabeca' value={taxs_detalhes.nome}/>

                    </div>
                    <div id='cabeca'>
                        <div>Estado:</div>
                        <input type='text' id='texto_cabeca' value={taxs_detalhes.estado}/>
                    </div>
                    <div id='cabeca'>
                        <div>IVA:</div>
                        <input type='text' id='texto_cabeca' value={taxs_detalhes.iva}/>
                    </div>
                
                    <div id='cabecas'>
                        <h5>STEP TARIF :</h5>            
                    </div>
            
            
            
                    <table id='eutabela'>
            <thead>
            <tr>
            <th>Quantidade inicial</th>
            <th>Quantidade final</th>
            <th>Preco unitario</th>
            
            </tr>
            </thead>
    
            
            {taxs_detalhes && <tbody className='lkj'>{(taxs_detalhes.intervalos).map((val,key)=>
            {
            return  <tr> 
            <td>{val.inicio}</td>
            <td>{val.fim}</td>
            <td>{val.preco}</td>
            
            </tr>
            
            }
            )}</tbody>}
    
            </table>
                
                        </div>}
           
                </div>
            </div>}
     
        {mensal &&  <div className='Venda-Diaria'>
        {aray &&   <div className='Totais'>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/vat (1).png')} /></div>
                        <div id="txts">IVA:</div>
                        <div id='valor'>{SomaIva(FilterData(aray))}Mzn</div>
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/gas-pump.png')} /></div>
                        <div id="txts">Taxa:</div>
                        <div id='valor'>{SomaTSC(FilterData(aray))}Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/flame.png')} /></div>
                        <div id="txts"> Val gas :</div>
                        <div id='valor'>{parseFloat(SomaVal(FilterData(aray))-SomaIva(FilterData(aray))-SomaTSC(FilterData(aray))).toFixed(2)   }Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/gas.png')} /></div>
                        <div id="txts">Total gas :</div>
                        <div id='valor'>{parseFloat(SomaMetros(FilterData(aray))).toFixed(2) } m3</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/tax.png')} /></div>
                        <div id="txts">Total Recebido:</div>
                        <div id='valor'>{SomaVal(FilterData(aray))} Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/visa.png')} /></div>
                        <div id="txts">Visa:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/24-hours.png')} /></div>
                        <div id="txts">Conta Movel:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/paypal.png')} /></div>
                        <div id="txts">PayPal:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/payment-method.png')} /></div>
                        <div id="txts">E-mola:</div>
                        <div id='valor'>{SomaVal(FilterData(FilterEmola(aray)))}</div>
                        
                    </div>
                   
            </div>}
            <div className='Totais'>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/pos-terminal.png')} /></div>
                        <div id="txts">RecargaAki:</div>
                        <div id='valor'>{SomaVal(FilterData(FilterRAKI(aray)))}</div>
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/seller.png')} /></div>
                        <div id="txts">Revendedor:</div>
                        <div id='valor'>{SomaVal(FilterData(FilterRev(aray)))} Mzn</div>
                    </div>
                                  
            </div>
            
  <div className='datadefin'>
      
      <img  id="imagem_vendas"src={require('./images/clock.png')}  />
            
                <div>
                Inicio
                <DatePicker onChange={onChange} value={valori}/>
                </div>
                
                <img  id="imagem_vendas"src={require('./images/clock.png')}  />
            
                <div>
                Fim
                <DatePicker onChange={onChangef} value={valorf} maxDate={new Date()}/>
                </div>
                <img  id="imagem_vendas"src={require('./images/debt.png')}  />
            
                <div>Metodo de Pagamento<select id="combo" onChange={(e)=>{
                                const rev=e.target.value;
                                setRevendedor(rev);
                            }}>
             
                            
                                <option value="">NENHUM</option>
                                <option value="numerario">Revendedor</option>
                                <option value="Mpesa">M-PESA</option>
                                <option value="emola">E-MOLA</option>
                                <option value="recargaaki">RECARGAAKI</option>
                               
                                <option value="CONTA MOVEL">CONTA MOVEL</option>
                                <option value="OPERADOR">Visa</option>
                                <option value="OPERADOR">M-KeSH</option>
                                
                            </select>
               </div>
               <img  id="imagem_vendas"src={require('./images/map.png')}  />
                   
               <div>Zona<select id="combo" onChange={(e)=>{
                                const zona=e.target.value;
                                setBairro(zona);
                            }}>


             
                            
                                <option value="">NENHUM</option>
                                <option value="aeroporto">Aeroporto</option>
                                <option value="junho"> 25 de Junho </option>
                                <option value="coop" >Coop PH5 </option>
                                <option value="coop">coop PH6</option> 
                                <option value="Munhuana">Munhuana</option> 
                            </select>
               </div>
               
               
                <img  id="imagem_vendas"src={require('./images/printer.png')}  />
                   
                   <ReactToPrint
                           trigger={() => {
                              return <a  href="#">   
                              <button  id="opcao" value="Nao" onClick={Send} >Imprimir
                              </button>
                  </a>;
                           }}
                           content={() => printRelaResumo.current}
                         />
<img  id="imagem"src={require('./images/excel.png')}  />
            
<ReactToExcel 
                    id='opcao'
                    table='tabela_todos'
                    filename='Vendas_Resumo'
                    sheet='sheet 1'
                    buttonText='Exportar'/>
  
                     </div>
            <div className='ContentorTabela'>
            <table id="tabela_todos">
            <thead>
            <tr>
            <th>idCliente</th>
            <th>idContador</th>
            <th>Valor Pago</th>
            <th>data</th>
            <th>m3</th>
            <th>iva</th>
            <th>morada</th>
            
            </tr>
            </thead>
    
     
         {aray && <tbody>{FilterData(Search(FilterBairro(aray))).map((val,key)=>
            {
            return  <tr> 
            <td>{val.idCliente}</td>
            <td>{val.idContador}</td>
            <td>{ parseFloat(val.valor_pago).toFixed(2)}</td>
            <td>{val.data_de_compra}</td>
            <td>{parseFloat(val.metroscubicos).toFixed(2) }</td>
            <td>{parseFloat(val.iva).toFixed(2)}</td>
            <td>{val.morada}</td>
            
           
         
            </tr>
            
            }
            )}</tbody>}
    
            </table>
            </div>

                                 
        </div>}
        {taxas && <div>
            <div>
            <div className='Filtro'>
        <button  id="opcao" value="Nao"  onClick={()=>{setTipotaxaf('df');setTipotaxi(null); }}>Taxas Adicionais e Fixas </button>
        <button  id="opcao" value="Nao  "  onClick={()=>{setTipotaxi('df');setTipotaxaf(null)}}>Taxa Inicial de Instalacao</button>
     
        </div>
      
                         
            </div>
            {tipotaxaf &&
                            <div>
                                       {d && <select id="inpo" onChange={(e)=>{
                            const provincia=e.target.value;
                        }}>
         
         {d.map((ct,key)=>{
        return<option value="">{ct.nome}</option>})
}
                            </select>
            }
     
                                    <div className='Totais'>
                                    <div className='info'>
                                    <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/flame.png')} /></div>
          <div id="txts">Preco(MT/GJ):</div>
                        <div id='valor'>{taxas[3].preco}</div>
                    </div>
                    <div className='info'>
                    <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/flame.png')} /></div>
                        <div id="txts">Valor Calorifico(MJ/m3):</div>
                        <div id='valor'>{taxas[4].preco}</div>
                    </div>
                  
                    <div className='info'>
                    <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/gas-pump.png')} /></div>
                        <div id="txts">TSC(MT/GJ):</div>
                        <div id='valor'>{taxas[6].preco}</div>
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/vat (1).png')} /></div>
                        <div id="txts">IVA(MT/GJ):</div>
                        <div id='valor'>{taxas[2].preco}%</div>
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/gas-pump.png')} /></div>
                        <div id="txts">TSC(MT/m3):</div>
                        <div id='valor'>{taxas[0].preco}Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/flame.png')} /></div>
                        <div id="txts">Preco(MT/m3):</div>
                        <div id='valor'>{taxas[1].preco}Mzn</div>
                        
                    </div>
                   
            </div>
            <div>
            <div className='Sistema_rel'>
            <div className='form-inners'>

            
        <div className="form-groups">
                    <FaIcons.FaDollarSign color='gray' className='size'/> <label>Preco(MT/GJ)</label>
                    <input type="number" name="username" id="username" minLength={9} maxLength={9}   onChange={e => setDiariotax({ ...diariotax, precogj: e.target.value })} value={diariotax.precogj} />

                </div>
      
                <div className="form-groups">
                    <FaIcons.FaFireAlt color='gray' className='size'/><label>Valor Calorifico(MJ/m3)</label>
                    <input type="number" name="username" id="username" minLength={5}   onChange={e => setDiariotax({ ...diariotax, valorcalor: e.target.value })} value={diariotax.valorcalor} />

                </div>
                <div className="form-groups">
                    <FaIcons.FaGasPump color='gray' className='size'/><label>Taxa sobre Combustiveis(MT/GJ)</label>
                    <input type="number" name="username" id="username" minLength={9} maxLength={9}    onChange={e => setDiariotax({ ...diariotax, tsc: e.target.value })} value={diariotax.tsc} />

                </div>
              
                <input type="submit" onClick={UpdateHandler} value="Actualizar"/>
           
      
        </div>
            </div>
            
                </div>
                 <div>
            <div className='Sistema_rel'>
                    <h3>Adicionar Taxas</h3>
              
               </div>
            
                </div>
                <div>
            <div className='Sistema_rel'>
            <div>Nome da Taxa: <input id='inpo' type='text'  required/></div>
              
              <div>Cobranca:<select id="inpo" onChange={(e)=>{
                            const provincia=e.target.value;
                        }}>
         
                        
                            <option value="">unitaria</option>
                            <option value="m-pesa">Percentual</option>
                            
                        </select></div>
              
              <div>Valor:<input id='inpo' type='text'  required  /></div>
              
              <input type="submit"  value="Adicionar"/>
           


               </div>
            
                </div>
            


                            </div>
            }
            {tipotaxi && <div>
                {d && <select id="inpo" onChange={(e)=>{
                            const provincia=e.target.value;
                        }}>
         
         {d.map((ct,key)=>{
        return<option value="">{ct.nome}</option>})
}
                            </select>
            }
     
                                    <div className='Totais'>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/easy-installation.png')} /></div>
                        <div id="txts">Taxa de Instalacao:</div>
                        <div id='valor'>2 500.00MZN</div>
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/tax.png')} /></div>
                        <div id="txts">Tipo de Cobranca:</div>
                        <div id='valor'>10% por compra</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/clock.png')} /></div>
                        <div id="txts">Periodicidade de Cobranca:</div>
                        <div id='valor'>{taxas[0].preco}Mzn</div>
                        
                    </div>

            </div>
            <div>
            <div className='Sistema_rel'>
              
               <div>Taxa de Instalacao: <input id='inpo' type='text' onChange={(e)=>{setDiariotax({...diariotax,m3:e.target.value})}} value={diariotax.m3} required/></div>
              
               <div>Tipo de Cobranca:<select id="inpo" onChange={(e)=>{
                            const provincia=e.target.value;
                        }}>
         
                        
                            <option value="">Activar cobranca percentual</option>
                            <option value="">Activar cobranca Unitaria</option>
                           
                            <option value="m-pesa">Desativar</option>
                         </select>
                         
                        </div>
               <div>Valor<input id='inpo' type='text'  required/></div>
               <input type="submit"  value="Actualizar"/>
            </div>
            
                </div>
                </div>}
            
            </div>}
        {caixa && <div className='Caixa'>
        <div className='Totais'>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/visa.png')} /></div>
                        <div id="txts">Visa:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/24-hours.png')} /></div>
                        <div id="txts">Conta Movel:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/payment-method.png')} /></div>
                        <div id="txts">M pesa:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/pos-terminal.png')} /></div>
                        <div id="txts">RecargaAki:</div>
                        <div id='valor'>{SomaVal(FilterData(FilterRAKI(FilterBairro(aray))))}</div>
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/transaction.png')} /></div>
                        <div id="txts">E-mola:</div>
                        <div id='valor'>{SomaVal(FilterData(FilterEmola(FilterBairro(aray))))}</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/token.png')} /></div>
                        <div id="txts">MKesh:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                   
            </div>
            <div className='tabela'>
            <table id='eutabela'>
            <thead>
            <tr>
            <th>Revendedor</th>
            <th>Valor Recebido</th>
            <th>Comissao Revendedor</th>
            <th>N.Vendas Realizadas</th>
            <th>N.Recargas Geradas</th>
            <th>N.Recargas Defeituosas</th>
           
            </tr>
            </thead>
    
            {aray && <tbody>
            <tr> 
            <td>Emola</td>
            <td>{SomaVal(FilterData(FilterEmola(FilterBairro(aray))))  }</td>
            <td> --</td>
            <td>{FilterData(FilterEmola(FilterBairro(aray))).length}</td>
            <td>{FilterData(FilterEmola(FilterBairro(aray))).length }</td>
            <td>0</td>
    
            
           
         
            </tr>
            <tr> 
            <td>RecargaAKI</td>
            <td>{SomaVal(FilterData(FilterRAKI(FilterBairro(aray) )))  }</td>
            <td> --</td>
            <td>{FilterData(FilterRAKI(FilterBairro(aray))).length}</td>
            <td>{FilterData(FilterRAKI(FilterBairro(aray))).length }</td>
            <td>0</td>
    
            
           
         
            </tr>
            
            </tbody>}
    
            </table>
   


            </div>
            <div>

            <div className='datadefin'>
            <img  id="imagem_vendas"src={require('./images/clock.png')}  />
     
     <div>
     Inicio
     <DatePicker onChange={onChange} value={valori}/>
     </div>
     <img  id="imagem_vendas"src={require('./images/clock.png')}  />

     <div>
     Fim
     <DatePicker onChange={onChangef} value={valorf} maxDate={new Date()}/>
     </div>
     
 
 <div>
 <img  id="imagem"src={require('./images/excel.png')}  />
            <ReactToExcel 
                    id='opcao'
                    table='eutabela'
                    filename='Revendedores'
                    sheet='sheet 1'
                    buttonText='Exportar'/>


              
</div>
<img  id="imagem_vendas"src={require('./images/map.png')}  />
    
<div>Zona<select id="combo" onChange={(e)=>{
                                const zona=e.target.value;
                                setBairro(zona);
                            }}>


             
                            
                                <option value="">NENHUM</option>
                                <option value="aeroporto">Aeroporto</option>
                                <option value="junho"> 25 de Junho </option>
                                <option value="coop" >Coop PH5 </option>
                                <option value="coop">coop PH6</option> 
                                <option value="Munhuana">Munhuana</option> 
                            </select>
               </div>

               
            </div>
  
            </div>
            
            </div>}
        {personaliza && <div className='Venda-Diaria'>
            <div className='datadefin'>
            <img  id="imagem_vendas"src={require('./images/clock.png')}  />
     
            <div>
            Inicio
            <DatePicker onChange={onChange} value={valori}/>
            </div>
            <img  id="imagem_vendas"src={require('./images/clock.png')}  />
     
            <div>
            Fim
            <DatePicker onChange={onChangef} value={valorf} maxDate={new Date()}/>
            </div>
            <img  id="imagem_vendas"src={require('./images/debt.png')}  />
        
        <div>Metodo de Pagamento<select id="combo" onChange={(e)=>{
                        const provincia=e.target.value;
                    }}>
     
                    
                        <option value="">NENHUM</option>
                        <option value="m-pesa">Revendedor</option>
                        <option value="m-pesa">M-PESA</option>
                        <option value="E-MOLA">E-MOLA</option>
                        <option value="RECARGAAKI">RECARGAAKI</option>
                        <option value="CONTA MOVEL">CONTA MOVEL</option>
                        <option value="OPERADOR">Visa</option>
                        <option value="OPERADOR">M-KeSH</option>
                        
                    </select>
       </div>
       <img  id="imagem_vendas"src={require('./images/map.png')}  />
           
       <div>Zona<select id="combo" onChange={(e)=>{
                        const provincia=e.target.value;
                    }}>
     
                    
                        <option value="">NENHUM</option>
                        <option value="m-pesa">Aeroporto</option>
                        
                    </select>
       </div>
     
         
         
            <img  id="imagem_vendas"src={require('./images/printer.png')}  />
               
               <ReactToPrint
                       trigger={() => {
                          return <a  href="#">   
                          <button  id="opcao" value="Nao" onClick={Send} >Imprimir
                          </button>
              </a>;
                       }}
                       content={() => mcasa.current}
                     />
            
            </div>
            <div className='Totais'>
                    <div className='info'>
                    <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/vat (1).png')} /></div>
                        <div id="txts">IVA:</div>
                        <div id='valor'>{diariod.iva} Mzn</div>
                    </div>
                    <div className='info'>
                    <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/gas-pump.png')} /></div>
                        <div id="txts">TSC:</div>
                        <div id='valor'>{diariod.tsc} Mzn</div>
                        
                    </div>
                    <div className='info'>
                    <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/flame.png')} /></div>
                        <div id="txts"> Val gas:</div>
                        <div id='valor'>{diariod.valor} Mzn</div>
                        
                    </div>
                    <div className='info'>
                    <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/gas.png')} /></div>
                        <div id="txts">Total Gas:</div>
                        <div id='valor'>{diariod.m3} m3</div>
                        
                    </div>
                    <div className='info'>
                    <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/tax.png')} /></div>
                        <div id="txts">Total Pago:</div>
                        <div id='valor'>{diariod.total} Mzn</div>
                        
                    </div>
                    <div className='info'>
                    <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/seller.png')} /></div>
                        <div id="txts">Acessos :</div>
                        <div id='valor'>{diariod.total} </div>
                    </div>
                   
            </div>
            <div className='Totais'>
                  
                                  
            </div>

            
     
            </div>}
        <ComponentToPrint ref={printRelaResumo}>
            <div className='Relatorios'>
            <div className='Sistema_rel'>
            <div id="icon"><img  id="imagem_vendas"src={require('./images/gears copy.png')}  />
                        </div>
                <div id='texts'>
                    <h3>MOZAMBIQUE PREPAYMENT SYSTEM
               </h3>
               <h4>Tipo de relatorio:<h5>Registro de Vendas</h5>
               </h4>
               </div>
            </div>
            {aray &&   <div className='Totais'>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/vat (1).png')} /></div>
                        <div id="txts">IVA:</div>
                        <div id='valor'>{SomaIva(FilterData(aray))}Mzn</div>
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/gas-pump.png')} /></div>
                        <div id="txts">Taxa:</div>
                        <div id='valor'>{SomaTSC(FilterData(aray))}Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/flame.png')} /></div>
                        <div id="txts"> Val gas :</div>
                        <div id='valor'>{parseFloat(SomaVal(FilterData(aray))-SomaIva(FilterData(aray))-SomaTSC(FilterData(aray))).toFixed(2)   }Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/gas.png')} /></div>
                        <div id="txts">Total gas :</div>
                        <div id='valor'>{parseFloat(SomaMetros(FilterData(aray))).toFixed(2) } m3</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/tax.png')} /></div>
                        <div id="txts">Total Recebido:</div>
                        <div id='valor'>{SomaVal(FilterData(aray))} Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/visa.png')} /></div>
                        <div id="txts">Visa:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/24-hours.png')} /></div>
                        <div id="txts">Conta Movel:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/paypal.png')} /></div>
                        <div id="txts">PayPal:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/payment-method.png')} /></div>
                        <div id="txts">E-mola:</div>
                        <div id='valor'>{SomaVal(FilterData(FilterEmola(aray)))}</div>
                        
                    </div>
                    <div className='Totais'>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/pos-terminal.png')} /></div>
                        <div id="txts">RecargaAki:</div>
                        <div id='valor'>{SomaVal(FilterData(FilterRAKI(aray)))}</div>
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/seller.png')} /></div>
                        <div id="txts">Revendedor:</div>
                        <div id='valor'>{SomaVal(FilterData(FilterRev(aray)))} Mzn</div>
                    </div>
                                  
            </div>       
            </div>
            
            }
            {aray && <div>
                <table id="tabela_todos">
            <thead>
            <tr>
            <th>idCliente</th>
            <th>idContador</th>
            <th>Valor Pago</th>
            <th>data</th>
            <th>m3</th>
            <th>iva</th>
            <th>morada</th>
            
            </tr>
            </thead>
    
     
         {aray && <tbody>{FilterData(Search(FilterBairro(aray))).map((val,key)=>
            {
            return  <tr> 
            <td>{val.idCliente}</td>
            <td>{val.idContador}</td>
            <td>{ parseFloat(val.valor_pago).toFixed(2)}</td>
            <td>{val.data_de_compra}</td>
            <td>{parseFloat(val.metroscubicos).toFixed(2) }</td>
            <td>{parseFloat(val.iva).toFixed(2)}</td>
            <td>{val.morada}</td>
            
           
         
            </tr>
            
            }
            )}</tbody>}
    
            </table>
                </div>}

            </div> 
          
                      
        </ComponentToPrint>
        <ComponentToPrint ref={PrintCaixa}>
        <div className='Relatorios'>
        <div className='Sistema_rel'>
            <div id="icon"><img  id="imagem_vendas"src={require('./images/gears copy.png')}  />
                        </div>
                <div id='texts'>
                    <h3>MOZAMBIQUE PREPAYMENT SYSTEM
               </h3>
               <h4>Tipo de relatorio:<h5>Total Revendedor</h5>
               </h4>
               <h5></h5>
               </div>
              
            </div>
          
        {caixa && <div className='Caixa'>
        <div className='Totais'>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/visa.png')} /></div>
                        <div id="txts">Visa:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/24-hours.png')} /></div>
                        <div id="txts">Conta Movel:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/payment-method.png')} /></div>
                        <div id="txts">M pesa:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/pos-terminal.png')} /></div>
                        <div id="txts">RecargaAki:</div>
                        <div id='valor'>0 Mzn</div>
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/transaction.png')} /></div>
                        <div id="txts">E-mola:</div>
                        <div id='valor'>00 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/token.png')} /></div>
                        <div id="txts">MKesh:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                   
            </div>
            <table id='eutabela'>
            <thead>
            <tr>
            <th>Revendedor</th>
            <th>Valor Recebido</th>
            <th>Comissao Revendedor</th>
            <th>N.Compras Realizadas</th>
            <th>N.Recargas Geradas</th>
            <th>N.Recargas Defeituosas</th>
           
            </tr>
            </thead>
    
     
    <tbody> <tr> 
            <td>M-pesa</td>
            <td>25 000.0</td>
            <td>10%</td>
            <td>20</td>
            <td>20</td>
            <td>6</td>
           
            </tr>
           </tbody>
    
            </table>
   


      
        </div>
        }</div>
        </ComponentToPrint>
        <ComponentToPrint ref={mcasa}>
            <div className='Relatorios'>
            <div className='Totais'>
                    <div className='info'>
                    <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/vat (1).png')} /></div>
                        <div id="txts">IVA:</div>
                        <div id='valor'>{diariod.iva} Mzn</div>
                    </div>
                    <div className='info'>
                    <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/gas-pump.png')} /></div>
                        <div id="txts">TSC:</div>
                        <div id='valor'>{diariod.tsc} Mzn</div>
                        
                    </div>
                    <div className='info'>
                    <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/flame.png')} /></div>
                        <div id="txts"> Val gas:</div>
                        <div id='valor'>{diariod.valor} Mzn</div>
                        
                    </div>
                    <div className='info'>
                    <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/gas.png')} /></div>
                        <div id="txts">Total Gas:</div>
                        <div id='valor'>{diariod.m3} m3</div>
                        
                    </div>
                    <div className='info'>
                    <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/tax.png')} /></div>
                        <div id="txts">Total Pago:</div>
                        <div id='valor'>{diariod.total} Mzn</div>
                        
                    </div>
                    <div className='info'>
                    <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/seller.png')} /></div>
                        <div id="txts">Acessos :</div>
                        <div id='valor'>{diariod.total} </div>
                    </div>
                   
            </div>
            <div className='Totais'>
                  
                                  
            </div>
            <ResponsiveContainer width="100%" height={300}  className="casa">
      <AreaChart data={aray} >
        <defs>
            <linearGradient id="color" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor='#053f40' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#053f40' stopOpacity={0.05}></stop>
            </linearGradient>
            <linearGradient id="colors" x1="0" y1="0" x2="0" y2="1">

                <stop offset="0%" stopColor='#ca2210' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#ca2210' stopOpacity={0.05}></stop>
            </linearGradient>
            <linearGradient id="colorsa" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor='#ffa500' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#ffa500' stopOpacity={0.05}></stop>
            </linearGradient>
            <linearGradient id="colorsaa" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor='#ca2210' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#ca2210' stopOpacity={0.05}></stop>
            </linearGradient>
            <linearGradient id="colorsaaa" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor='#00FF00' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#00FF00' stopOpacity={0.05}></stop>
            </linearGradient>
            <linearGradient id="colorsaaaa" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor='#00FFFF' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#00FFFF' stopOpacity={0.05}></stop>
            </linearGradient>
        
        </defs>
        <Area dataKey="valor_pago" stroke="#053f40" fill="url(#color)"/>
        <Area dataKey="mpesa" stroke="#ca2210" fill="url(#colors)"/>
        <Area dataKey="emola" stroke="#ffa500" fill="url(#colorsa)"/>
        <Area dataKey="paypall" stroke="#ca2210" fill="url(#colorsaa)"/>
        <Area dataKey="ponto" stroke="#00FF00" fill="url(#colorsaaa)"/>
        <Area dataKey="visa" stroke="#00ffff" fill="url(#colorsaaaa)"/>
      
        <XAxis dataKey="data_de_compra"
        axisLine={false}
        tickLine={false}
        tickFormatter={str=>{
            const date=parseISO(str);
            if(date.getDate() %7==0){
                return  format(date,"MMM, d")
            }
            return ""
        }}/>
        <YAxis dataKey="valor_pago"
        axisLine={false}
        tickLine={false}
        tickCount={8}
        tickFormatter={number=>`${number.toFixed(2)}mil`}/>
        <Tooltip/>
        <CartesianGrid opacity={0.1} vertical={false}/>
      </AreaChart>
  </ResponsiveContainer>
          

            </div>
                </ComponentToPrint>
        </div>
}
export default AGestaVendas;
